import appApi from "@/api/appApi";
import { API_ENDPOINT } from "@/config/constants";
import { PopupChecker } from "@utils/popup-checker";

export default {
  async signup({
    email,
    password,
    first_name,
    middle_name,
    last_name,
    mobile_number,
    birthday
  }) {
    const { data } = await appApi.post("/site/signup", {
      email,
      password,
      first_name,
      middle_name,
      last_name,
      birthday,
      mobile_number
    });
    return data;
  },

  async loginBase({ email, password }) {
    const { data } = await appApi.post("/site/login", { email, password });
    return data;
  },

  async loginWithRB(rbJWT) {
    const { data } = await appApi.post("/site/check-rb-token", {
      id_token: rbJWT
    });
    return data;
  },

  async loginVk() {
    const popupChecker = new PopupChecker({
      url: `${API_ENDPOINT}/site/login-vkontakte`,
      name: "auth",
      postMessage: "auth_token"
    });

    const { token } = await popupChecker.observe();

    return {
      data: { token },
      success: !!token
    };
  },

  async logout() {
    const { data } = await appApi.get(`/site/logout`);
    return data;
  },

  async relogin() {
    const response = await appApi.get(`/site/relogin`);
    const { success, data: { token } = {} } = response.data;
    return {
      token,
      success: success && !!token
    };
  },

  async resetPasswordRequest(email) {
    const { data } = await appApi.post(`/site/request-password-reset`, {
      email
    });
    return data;
  },

  async resetPassword(token, password) {
    const { data } = await appApi.post(`/site/reset-password?token=${token}`, {
      password
    });
    return data;
  }
};
